import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const themeConfig = (mode = "light") => {
    return createTheme({
        palette: {
            mode, // Ensures light/dark mode switching
            primary: {
                main: "#007bff",
            },
            secondary: {
                main: "#333",
            },
            background: {
                default: mode === "dark" ? "#121212" : "#f8f9fa",
                paper: mode === "dark" ? "#1e1e1e" : "#fff",
            },
            text: {
                primary: mode === "dark" ? "#fff" : "#000",
                secondary: mode === "dark" ? "#bbb" : "#444",
            },
        },
    });
};

// Ensure the theme is valid before applying responsiveFontSizes
const getTheme = (mode) => {
    const theme = themeConfig(mode);
    return theme && theme.typography ? responsiveFontSizes(theme) : theme;
};

export default getTheme;
